"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var antd_2 = require("antd");
var TableActionSelect_1 = require("../../components/table_actions/TableActionSelect");
var WrapTableActions_1 = require("../../components/table_actions/WrapTableActions");
var ToolBarButtonsOnly_1 = require("../../components/toolbars/ToolBarButtonsOnly");
var DlgSelectAvailAdmin = /** @class */ (function (_super) {
    __extends(DlgSelectAvailAdmin, _super);
    function DlgSelectAvailAdmin(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Логин',
                dataIndex: _this.props.data.dk_login,
                key: _this.props.data.dk_login,
                width: 250,
            }, {
                title: 'Имя',
                dataIndex: _this.props.data.dk_name,
                key: _this.props.data.dk_name,
                width: 250,
            }, {
                title: 'Действия',
                key: 'action',
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionSelect_1.default, { hint: "\u0432\u044B\u0431\u0440\u0430\u0442\u044C", onClick: function () {
                            if (_this.props.controller.OnSelect) {
                                _this.props.controller.OnSelect(record.key, record.login);
                            }
                        } }))); },
                width: 130
            }
        ];
        _this.state = { data: [], visible: false };
        return _this;
    }
    DlgSelectAvailAdmin.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible
            }, function () {
                if (data.visible) {
                    _this.props.data.LoadData();
                }
            });
        });
        this.SID_D = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
            });
        });
        this.setState({
            visible: false,
            data: []
        });
    };
    DlgSelectAvailAdmin.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
        this.props.data.UnSubscribe(this.SID_D);
    };
    DlgSelectAvailAdmin.prototype.onToolBarClick = function () {
        this.props.data.LoadData();
    };
    DlgSelectAvailAdmin.prototype.render = function () {
        var _this = this;
        return (React.createElement(antd_1.Modal, { title: "Выберите администратора", visible: this.state.visible, wrapClassName: "vertical-center-modal", closable: true, maskClosable: false, footer: React.createElement("div", null), onCancel: function () {
                if (_this.props.controller.onClose) {
                    _this.props.controller.onClose();
                }
            }, style: { minWidth: "720px" } },
            React.createElement("div", null,
                React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) }),
                React.createElement(antd_2.Table, { columns: this.columns, dataSource: this.state.data, size: "small", pagination: {
                        pageSize: 10,
                        showSizeChanger: false,
                        position: "bottom",
                        showQuickJumper: false,
                    } }))));
    };
    return DlgSelectAvailAdmin;
}(React.Component));
exports.default = DlgSelectAvailAdmin;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgSelectAvailAdmin.tsx
// module id = 2044
// module chunks = 0